import { doc, setDoc, getDoc, serverTimestamp } from 'firebase/firestore';
import { db } from './firebase';

export interface TermsAgreement {
  agreedAt: any;
  version: string;
  agreed: boolean;
}

// 規約に同意（ユーザーIDを引数で受け取る）
export const agreeToTerms = async (userId: string, version: string = '1.0') => {
  try {
    await setDoc(doc(db, 'users', userId, 'agreements', 'terms'), {
      agreedAt: serverTimestamp(),
      version: version,
      agreed: true
    });
    return { success: true };
  } catch (error: any) {
    console.error('Terms agreement error:', error);
    return { success: false, error: '規約同意の保存に失敗しました' };
  }
};

// 規約同意状態をチェック
export const checkTermsAgreement = async (userId: string): Promise<boolean> => {
  try {
    const docRef = doc(db, 'users', userId, 'agreements', 'terms');
    const docSnap = await getDoc(docRef);
    
    if (docSnap.exists()) {
      const data = docSnap.data();
      return data.agreed === true;
    }
    return false;
  } catch (error) {
    console.error('Check terms agreement error:', error);
    return false;
  }
};